import styled from 'styled-components';

export const ListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.grayVariations.murky};
  padding: 24px;
  min-width: 310px;
  margin-top: 24px;
  max-height: 384px;
  overflow: auto;
`;

export const PlaceholdersWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 8px;
`;

export const PlaceholdersItem = styled.div`
  display: flex;
  flex-direction: column;
  color: ${({ theme }) => theme.colors.primary.grey};
  & > span {
    color: ${({ theme }) => theme.colors.grayVariations.dark};
    font-weight: 400;
    font-size: 12px;
  }

  & > div {
    display: flex;
    align-items: center;
    gap: 4px;
    & > button {
      display: flex;
      border: none;
      background-color: transparent;
      cursor: pointer;
    }
  }
`;
